<template>
  <div class="menu-item-wrapper">
    <div class="menu-section">  
      <h3>Basic variant</h3>
      <CalicoMenuItem
        v-for="item in basicItems"
        :key="item.value"
        :value="item.value"
        :model-value="selectedBasic"
        @update:modelValue="selectedBasic = $event"
      >
        <span :class="['menu-label', 'body--medium']">{{ item.label }}</span>
      </CalicoMenuItem>
      <p>Selected {{ selectedBasic }}</p>
    </div>

    <div class="menu-section">
      <h3>Address variant</h3>
      <CalicoMenuItem
        v-for="item in addressItems"
        :key="item.value"
        address
        :value="item.value"
        :model-value="selectedAddress"
        @update:modelValue="selectedAddress = $event"
      >
        <div class="address-content">
          <span :class="['menu-sub-label', 'body--medium']">
            {{ item.label }}
          </span>
          <span :class="['menu-sub-label', 'body--xsmall']">
            {{ item.subLabel }}
          </span>
        </div>
      </CalicoMenuItem>
      <p>Selected {{ selectedAddress }}</p>
    </div>

    <div class="menu-section">
      <h3>Select Variant</h3>
      <CalicoMenuItem
        v-for="item in selectItems"
        :key="item.value"
        select
        :value="item.value"
        :model-value="selectedSelect"
        @update:modelValue="handleSelect($event)"
      >
        <span :class="['menu-label', 'body--medium']">{{ item.label }}</span>
      </CalicoMenuItem>
      <p>Selected: {{ selectedSelect.join(", ") }}</p>
    </div>
  </div>
</template>

<script>
import CalicoMenuItem from "@/components/calico/menuItem/index.vue";

export default {
  name: "CalicoMenuItemDemo",
  components: {
    CalicoMenuItem,
  },
  data() {
    return {
      basicItems: [
        { value: 1, label: "Option 1" },
        { value: 2, label: "Option 2" },
      ],
      selectedBasic: null,
      addressItems: [
        { value: 3, label: "Address 1", subLabel: "Street 123" },
        {
          value: 4,
          label: "Address 2",
          subLabel: "Avenue 456",
        },
      ],
      selectedAddress: null,

      selectItems: [
        { value: 5, label: "Option 1" },
        { value: 6, label: "Option 2" },
      ],
      selectedSelect: [],
    };
  },
  methods: {
    handleSelect(value) {
      if (this.selectedSelect.includes(value)) {
        this.selectedSelect = this.selectedSelect.filter(
          (item) => item !== value
        );
      } else {
        this.selectedSelect.push(value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-item-wrapper {
  @include stack-space($space-none);
  padding: $space-large;

  .menu-section {
    margin-bottom: $space-medium;
  }
}
</style>
